var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ecology"},[_c('div',{staticClass:"ban"}),_c('Part1'),_c('TimeLine'),_c('Part2'),_c('Part5'),_c('Part7')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }